import React, { useEffect, useMemo, useState } from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Modal,
  Image,
} from "react-native";
import { AppColors } from "../../../../utility/AppColors";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { AppImages } from "../../../../utility/AppImages";
import TokenInfoModal from "./TokenBalanceInfoPopup";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import Separator from "../../../../Components/Separator";
import { ScrollView } from "react-native-gesture-handler";
import { getUserProfile } from "../../../../services/authAPI";
import { toast } from "react-toastify";
import { getLoginData } from "../../../../utility/AppStoreData";
import { ShowLoader } from "../../../../common/ShowLoader";
import {
  CommonActions,
  StackActions,
  useNavigation,
} from "@react-navigation/native";
import { AppScreens } from "../../../Utility/AppScreens";
import { navigateToScreen } from "../../../../utility/NavigationHelper";
import CoinsBalanceInfoPopup from "./CoinsBalanceInfoPopup";
import SvgImage from "../../../../Components/choose-avatar-components/SvgImage";

const WalletPopup = ({
  isVisible,
  onClose,
  position,
  userProfileData,
  setDailyCheckInPopup,
  setChangesApproved,
  setCornfirmPurchaseBeltModal,
  setRedeemBalance,
}: {
  isVisible: boolean;
  onClose: () => void;
  position: { x: number; y: number; width: number; height: number };
  userProfileData: any;
  setDailyCheckInPopup?: (value: boolean) => void;
  setChangesApproved?: (value: boolean) => void;
  setCornfirmPurchaseBeltModal?: (value: boolean) => void;
  setRedeemBalance?: (value: boolean) => void;
}) => {
  if (!isVisible) return null;
  const deviceSize = useDeviceSize();
  const styles = useStyles();
  const navigation = useNavigation();
  const [modalVisible, setModalVisible] = useState(false);
  const [CoinsModalVisible, CoinsSetModalVisible] = useState(false);

  const [belts, setBelts] = useState([
    {
      id: 1,
      image: AppImages.icBronzeBelt,
      count: 0,
      backgroundColor: "#99633D",
      title: "Bronze",
      key: "bronze",
    },
    {
      id: 2,
      image: AppImages.icSilverBelt,
      count: 0,
      backgroundColor: "#9FA3A3",
      title: "Silver",
      key: "silver",
    },
    {
      id: 3,
      image: AppImages.icGoldBelt,
      count: 0,
      backgroundColor: "#DDBE6F",
      title: "Gold",
      key: "gold",
    },
    {
      id: 4,
      image: AppImages.icPlatinumBelt,
      count: 0,
      backgroundColor: "#FAFFFE",
      title: "Platinum",
      key: "platinum",
    },
  ]);

  useEffect(() => {
    if (userProfileData?.belts) {
      setBelts((prevBelts) =>
        prevBelts.map((belt) => ({
          ...belt,
          count: userProfileData.belts[belt.key] || 0, // Set count from API data
        }))
      );
    }
  }, [userProfileData]);

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={isVisible}
      onRequestClose={onClose}
    >
      <View style={styles.modalOverlay}>
        <TouchableOpacity style={styles.overlayBackground} onPress={onClose} />

        <View
          style={[
            styles.modalContent,
            {
              position: "absolute",
              top: position.y + 10,
              ...(deviceSize === DEVICE_SIZES.XS ||
              deviceSize === DEVICE_SIZES.SM
                ? {}
                : { left: position.x - 370 }),
              width:
                deviceSize === DEVICE_SIZES.XS
                  ? "97%"
                  : deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.MD ||
                    deviceSize === DEVICE_SIZES.LG
                  ? "55%"
                  : "30%",
              maxHeight: "90%",
            },
          ]}
        >
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              paddingBottom: 20,
            }}
          >
            <Text style={AppFontStyle.MEDIUM_ANYBODY_22}>
              My Wallet Credits
            </Text>
            <TouchableOpacity
              style={{
                justifyContent: "center",
                alignItems: "center",
              }}
              onPress={() => {
                onClose();
              }}
            >
              <Image
                source={AppImages.icCloseWhite}
                style={{
                  height:
                    // deviceSize === DEVICE_SIZES.SM ||
                    // deviceSize === DEVICE_SIZES.XS
                    //   ? 20
                    //   :
                    25,
                  width:
                    // deviceSize === DEVICE_SIZES.SM ||
                    // deviceSize === DEVICE_SIZES.XS
                    //   ? 20
                    //   :
                    25,
                }}
              />
            </TouchableOpacity>
          </View>

          <ScrollView
            contentContainerStyle={{
              flexGrow: 1,
              justifyContent: "center",
            }}
            style={[styles.scrollView, {}]}
            showsHorizontalScrollIndicator={false}
          >
            <View
              style={{
                backgroundColor: AppColors.black_191919,
                padding: 15,
                borderWidth: 1,
                borderRadius: 10,
                borderColor: AppColors.gray_828282,
                marginBottom: 20,
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Text style={AppFontStyle.BOLD_ANYBODY_16}>Token Balance</Text>
                <View>
                  <TouchableOpacity
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onPress={() => setModalVisible(true)}
                  >
                    <Image
                      source={AppImages.icInfoCircle}
                      style={{
                        height: 20,
                        width: 20,
                      }}
                    />
                  </TouchableOpacity>
                  <TokenInfoModal
                    visible={modalVisible}
                    onClose={() => setModalVisible(false)}
                  />
                </View>
              </View>
              <Separator
                color={AppColors.white}
                height={1}
                marginTop={10}
                marginBottom={10}
                marginHorizontal={0}
              />
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 10,
                  }}
                >
                  <Image
                    source={AppImages.icTokenKo}
                    style={{
                      height: 50,
                      width: 50,
                    }}
                  />
                  <Text
                    style={[
                      deviceSize === DEVICE_SIZES.XS
                        ? AppFontStyle.REGULAR_ANYBODY_30
                        : AppFontStyle.REGULAR_ANYBODY_32,
                      { textAlign: "center" },
                    ]}
                  >
                    {userProfileData?.tokens}
                  </Text>
                </View>
                <View>
                  <TouchableOpacity
                    style={{
                      padding: 5,
                      borderRadius: 5,
                      backgroundColor: AppColors.purple_912BFF,
                    }}
                    onPress={() => {
                      navigateToScreen(navigation, AppScreens.PurchaseScreen);
                      onClose();
                    }}
                  >
                    <Text
                      style={[
                        deviceSize === DEVICE_SIZES.XS
                          ? AppFontStyle.MEDIUM_ANYBODY_14
                          : AppFontStyle.MEDIUM_ANYBODY_16,
                        { textAlign: "center" },
                      ]}
                    >
                      Get more Tokens
                    </Text>
                  </TouchableOpacity>
                </View>
              </View>
            </View>
            <View
              style={{
                backgroundColor: AppColors.black_191919,
                padding: 15,
                borderWidth: 1,
                borderRadius: 10,
                borderColor: AppColors.gray_828282,
                marginBottom: 20,
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Text style={AppFontStyle.BOLD_ANYBODY_16}>Coins Balance</Text>
                <View
                  style={{
                    flexDirection: "row",
                    gap: 16,
                    alignItems: "center",
                  }}
                >
                  <TouchableOpacity
                    style={{
                      paddingVertical: deviceSize === DEVICE_SIZES.XS ? 4 : 6,
                      paddingHorizontal:
                        deviceSize === DEVICE_SIZES.XS ? 8 : 12,
                      borderRadius: 12,
                      borderWidth: 1,
                      borderColor: AppColors.gray_C4C4C4,
                      flexDirection: "row",
                      justifyContent: "space-between",
                      gap: 10,
                      alignItems: "center",
                    }}
                    onPress={() => {
                      setDailyCheckInPopup(true);
                      onClose();
                    }}
                  >
                    <Image
                      source={AppImages.icDailyCoins}
                      style={{
                        height: 34,
                        width: 41,
                      }}
                      resizeMode="contain"
                    />
                    <Text style={[AppFontStyle.BOLD_ANYBODY_16]}>
                      Daily coins
                    </Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onPress={() => CoinsSetModalVisible(true)}
                  >
                    <Image
                      source={AppImages.icInfoCircle}
                      style={{
                        height: 20,
                        width: 20,
                      }}
                    />
                  </TouchableOpacity>
                  <CoinsBalanceInfoPopup
                    visible={CoinsModalVisible}
                    onClose={() => CoinsSetModalVisible(false)}
                  />
                </View>
              </View>
              <Separator
                color={AppColors.white}
                height={1}
                marginTop={10}
                marginBottom={10}
                marginHorizontal={0}
              />
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 10,
                  }}
                >
                  <SvgImage src={AppImages.icCoinKo} variant="wallet" />
                  <Text
                    style={[
                      deviceSize === DEVICE_SIZES.XS
                        ? AppFontStyle.REGULAR_ANYBODY_30
                        : AppFontStyle.REGULAR_ANYBODY_32,
                      { textAlign: "center" },
                    ]}
                  >
                    {userProfileData?.coins}
                  </Text>
                </View>
                <View>
                  <TouchableOpacity
                    style={{
                      padding: 5,
                      borderRadius: 5,
                      backgroundColor: AppColors.purple_912BFF,
                    }}
                    onPress={() => {
                      setChangesApproved(true);
                      onClose();
                    }}
                  >
                    <Text
                      style={[
                        AppFontStyle.MEDIUM_ANYBODY_16,
                        { textAlign: "center" },
                      ]}
                    >
                      Earn more coins
                    </Text>
                  </TouchableOpacity>
                </View>
              </View>
            </View>
            <View>
              <Text
                style={[
                  AppFontStyle.BOLD_ANYBODY_16,
                  {
                    marginBottom: 10,
                  },
                ]}
              >
                Total Belts
              </Text>
              <View
                style={{
                  backgroundColor: AppColors.black_191919,
                  padding: 15,
                  borderWidth: 1,
                  borderRadius: 10,
                  borderColor: AppColors.gray_828282,
                  marginBottom: 20,
                }}
              >
                <View style={styles.gridContainer}>
                  {belts.map((belt) => (
                    <View
                      key={belt.id}
                      style={[
                        styles.beltCard,
                        // { backgroundColor: belt.backgroundColor },
                      ]}
                    >
                      <Text style={AppFontStyle.BOLD_ANYBODY_16}>
                        {belt.title}
                      </Text>
                      <View
                        style={{
                          width: "100%",
                          alignItems: "flex-end",
                        }}
                      >
                        <View
                          style={{
                            width:
                              deviceSize === DEVICE_SIZES.SM ||
                              deviceSize === DEVICE_SIZES.XS
                                ? 100
                                : 119,
                            height:
                              deviceSize === DEVICE_SIZES.SM ||
                              deviceSize === DEVICE_SIZES.XS
                                ? 50
                                : 54,
                            borderRadius: 5,
                            borderColor: AppColors.black_161719,
                            backgroundColor: belt.backgroundColor,
                            borderWidth: 1,
                            justifyContent: "center",
                            alignItems: "flex-end",
                            paddingRight:
                              deviceSize === DEVICE_SIZES.XS ? 5 : 10,
                          }}
                        >
                          <Image
                            source={belt.image}
                            style={styles.beltImage}
                            resizeMode="contain"
                          />
                          <View style={styles.numberContainer}>
                            <Text style={AppFontStyle.MEDIUM_ANYBODY_18}>
                              {belt.count}
                            </Text>
                          </View>
                        </View>
                      </View>
                    </View>
                  ))}
                </View>
                <View
                  style={{
                    alignItems: "flex-end",
                  }}
                >
                  <TouchableOpacity
                    style={{
                      padding: 5,
                      borderRadius: 5,
                      backgroundColor: AppColors.purple_912BFF,
                    }}
                    onPress={() => {
                      setCornfirmPurchaseBeltModal(true);
                      onClose();
                    }}
                  >
                    <Text
                      style={[
                        AppFontStyle.MEDIUM_ANYBODY_16,
                        { textAlign: "center" },
                      ]}
                    >
                      Buy Belts
                    </Text>
                  </TouchableOpacity>
                </View>
              </View>
            </View>
            <Separator
              color={AppColors.gray_C4C4C4}
              height={1}
              marginTop={0}
              marginBottom={20}
              marginHorizontal={0}
            />
            <View>
              <Text
                style={[
                  AppFontStyle.BOLD_ANYBODY_16,
                  {
                    marginBottom: 10,
                  },
                ]}
              >
                Credit Balance
              </Text>
              <View
                style={{
                  backgroundColor: AppColors.black_191919,
                  padding: 15,
                  borderWidth: 1,
                  borderRadius: 10,
                  borderColor: AppColors.gray_828282,
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Text
                    style={[
                      deviceSize === DEVICE_SIZES.XS
                        ? AppFontStyle.REGULAR_ANYBODY_24
                        : AppFontStyle.REGULAR_ANYBODY_32,
                      { textAlign: "center" },
                    ]}
                  >
                    {userProfileData?.credits}
                  </Text>
                  <View>
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        borderRadius: 5,
                        overflow: "hidden",
                      }}
                    >
                      <View
                        style={{
                          backgroundColor: AppColors.appGreenColor_51AF07,
                          padding: 6,
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Text
                          style={
                            deviceSize === DEVICE_SIZES.XS
                              ? AppFontStyle.MEDIUM_ANYBODY_14
                              : AppFontStyle.MEDIUM_ANYBODY_16
                          }
                        >
                          £{userProfileData?.balance}
                        </Text>
                      </View>

                      <TouchableOpacity
                        style={{
                          backgroundColor: AppColors.purple_912BFF,
                          padding: 6,
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        onPress={() => {
                          userProfileData?.stripeCustomerId
                            ? setRedeemBalance(true)
                            : toast.error(
                                "Please create a stripe account first"
                              );
                          navigateToScreen(
                            navigation,
                            AppScreens.MyProfileWebScreen
                          );
                          onClose();
                        }}
                      >
                        <Text
                          style={
                            deviceSize === DEVICE_SIZES.XS
                              ? AppFontStyle.MEDIUM_ANYBODY_14
                              : AppFontStyle.MEDIUM_ANYBODY_16
                          }
                        >
                          Redeem Credits
                        </Text>
                      </TouchableOpacity>
                    </View>
                  </View>
                </View>
              </View>
            </View>
          </ScrollView>
        </View>
      </View>
    </Modal>
  );
};

const useStyles = CreateResponsiveStyle(
  {
    modalOverlay: {
      flex: 1,
      backgroundColor: AppColors.blackTrans_000000a8,
      justifyContent: "center",
      alignItems: "center",
    },
    scrollView: {
      width: "100%",
      flex: 1,
      // maxHeight: 600,
    },
    overlayBackground: {
      position: "absolute",
      width: "100%",
      height: "100%",
    },
    modalContent: {
      backgroundColor: AppColors.purple_453B50,
      padding: 24,
      borderRadius: 30,
      elevation: 5,
      borderWidth: 1,
      borderColor: AppColors.gray_A6A3AA,
    },
    gridContainer: {
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "space-between",
      // padding: 10,
    },
    beltCard: {
      backgroundColor: AppColors.purple_453B50,
      width: "48%",
      borderRadius: 6,
      alignItems: "center",
      justifyContent: "center",
      marginBottom: 10,
      padding: 10,
      borderColor: AppColors.black_161719,
      borderWidth: 1,
      gap: 10,
    },
    beltImage: {
      width: 78,
      height: 59,
      position: "absolute",
      left: -50,
    },
    numberContainer: {
      backgroundColor: AppColors.black,
      borderRadius: 10,
      paddingHorizontal: 15,
      paddingVertical: 5,
      width: 75,
      height: 44,
      justifyContent: "center",
      alignItems: "center",
    },
  },
  {
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.SM]: {
      numberContainer: {
        width: 69,
        height: 40,
      },
      beltImage: {
        width: 60,
        height: 45,
        left: -40,
      },
      modalContent: {
        padding: 20,
      },
    },
    [DEVICE_SIZES.XS]: {
      numberContainer: {
        width: 64,
        height: 40,
      },
      beltImage: {
        width: 60,
        height: 45,
        left: -30,
      },
      modalContent: {
        padding: 20,
      },
    },
  }
);

export default WalletPopup;
